export default {
  feedback: {
    reasons: "Gründe",
    reason: "Grund",
    feeling: "Gesichtsausdruck",
    feeling_enum: {
      BAD: "schlecht",
      SAD: "traurig",
      NORMAL: "Normal",
      HAPPY: "fröhlich",
      ECSTATIC: "sehr glpcklich"
    },
    title: "Feedback {0} / {1}",
    comment: "Beschreibung"
  }
};
